export default __webpack_public_path__ + "static/destinations-asia-thrill-rafting-b683372aec981bbdeec7534cf3aaaa60.jpg";